import React from 'react';
import { Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomTooltipComponent = styled(
  ({ bgcolor = '#e0e7ff', color = '#4338ca', placement = 'top', ...props }) => (
    <Tooltip
      {...props}
      placement={placement}
      arrow
      classes={{ popper: props.className }}
    />
  )
)(
  ({ bgcolor = '#e0e7ff', color = '#4338ca' }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: bgcolor,
      color,
      fontSize: '0.8rem',
      fontWeight: 'bold',
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: bgcolor,
    },
  })
);

export default CustomTooltipComponent;